import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import Modal from "../../../utils/customModal";
import { withTranslation } from "react-i18next";
import TokenComponent from "../../../shared/token";
import { MOD_PROVID } from "../../../../permissions";
import * as instanceActions from "../../../../Redux/api";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
import TableAdmissions from "../../../shared/admissions/table";
import { getModules } from "../../../../Redux/reducer/clients";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import ProviderTemporal from "../../../shared/provider/providerTemporal";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import { getAuthenticatedClientModules } from "../../../../Redux/actions/clientActions";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
  getNumberApprovals,
} from "../../../utils/functions";
import {
  getPendingProviders,
  getTotalPendingProviders,
} from "../../../../Redux/reducer/providers";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
let signal;
export class InvitationApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: [],
      page: 0,
      sizePerPage: 10,
      contentReady: false,
      modal: { show: false, content: null, onClose: undefined },
      token: { show: false, code: null },
      data: { approve: undefined, elements: undefined },
      menus: [],
      list: true,
      component: false,
      companyId: 0,
      providerId: 0,
    };
    this.controller = new AbortController();
    signal = this.controller.signal;
  }

  componentDidMount() {
    var customFilters = this.getFilters();

    this.props.setFilters({
      filterItems: customFilters,
      filterSearch: this.searchFnc,
    });

    if (this.props.clientModules.length <= 0) {
      this.props.getModules();
    }

    return this.getPendingData();
  }

  componentWillUnmount() {
    this.props.actions.clearPendingProviders();
    this.controller.abort();
  }

  getFilters() {
    return [
      {
        name: `${this.props.t("general.filters.name")}`,
        property: "provider.institution.name",
        operator: "eq",
      },
      {
        name: `${this.props.t("general.filters.identification")}`,
        property: "provider.institution.businessId",
        operator: "eq",
      },
    ];
  }

  getPendingData() {
    const { getInvitationProviders } = this.props.actions;
    const { page, sizePerPage, filter } = this.state;
    return getInvitationProviders(page, sizePerPage, filter, signal).then(
      () => {
        this.setState({ contentReady: true });
      }
    );
  }

  searchFnc = (property, value) => {
    var currentFilters = [];

    if (value !== "") {
      var operator = "";
      var customFilters = this.getFilters();

      customFilters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });

      currentFilters = [
        { property: property, operator: operator, value: value },
      ];
    }

    this.setState({ page: 0, filter: currentFilters }, () => {
      return this.getPendingData();
    });
  };

  getData() {
    const { pending, t } = this.props;
    var resultData = [];

    if (pending.length > 0) {
      pending.map((item) => {
        if (item.estado === "TRANSITORY") {
          item.estado = (
            <StatusBadge className="pending-client" type="default">
              {t("general.states.PENDING")}
            </StatusBadge>
          );
        }
        resultData.push({
          id: item?.provider?.id,
          cedJuridica: item?.businessId,
          name: (
            <a
              className={"admission-p record"}
              onClick={(e) => this.openInfoTemp(e, item)}
            >
              {item?.companyName}
            </a>
          ),
          payMethod:
            item?.provider?.accounts[0] != undefined
              ? t(
                  `general.paymethods.${item?.provider?.accounts[0].accountType}`
                )
              : "-",
          bank:
            item?.provider?.accounts[0] !== undefined
              ? item.provider.accounts[0].bicDestinationBank
              : "-",
          account:
            item?.provider?.accounts[0] !== undefined
              ? item.provider.accounts[0].accountNumber
              : "-",
          status: t(`general.inviteStates.${item?.provider?.invitationStatus}`),
          item,
        });
      });
    }

    return resultData;
  }

  openInfoTemp = (e, item) => {
    e.preventDefault();
    this.setState({ menus: [] }, () =>
      this.setState({
        list: false,
        component: true,
        companyId: item?.provider.relation.company.id,
        providerId: item?.provider.id,
      })
    );
  };

  closeInfo = () => {
    this.setState({
      list: true,
      component: false,
    });
  };

  handlerTableChange = ({ page, sizePerPage }) => {
    const { getInvitationProviders } = this.props.actions;

    return getInvitationProviders(
      page,
      sizePerPage,
      this.state.filter,
      signal
    ).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  closeModal = () => {
    this.setState({
      modal: { show: false, content: null, onClose: undefined },
    });
  };

  finishAdmission = () => {
    const { t } = this.props;
    var buttons = {
      SelBtn: {
        text: `${t("general.buttons.continue")}`,
        action: this.closeModal,
      },
    };

    var content = sucessInfoModal(
      `${t("admissions.successModal.title")}`,
      `${t("admissions.successModal.message")}`,
      buttons
    );

    this.setState({
      modal: { content: content, show: true, showClose: false },
    });
  };

  validate = ({ validToken = null }) => {
    const { token } = this.state;

    if (validToken === null) {
      token.show = true;
      this.setState({ token });
    } else {
      token.show = false;
      token.code = validToken;
      this.setState({ token }, () => this.commitActions());
    }
  };

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({ menus });
  };

  getHeaders() {
    const { menus } = this.state;
    const { t } = this.props;
    return [
      { selector: "name", name: `${t("admissions.headers.suppliers.name")}` },
      {
        selector: "cedJuridica",
        name: `${t("admissions.headers.suppliers.id")}`,
      },
      {
        selector: "payMethod",
        name: `${t("admissions.headers.suppliers.payMethod")}`,
      },
      { selector: "bank", name: `${t("admissions.headers.suppliers.bank")}` },
      {
        selector: "account",
        name: `${t("admissions.headers.suppliers.account")}`,
      },
      {
        selector: "status",
        name: `${t("admissions.headers.suppliers.status")}`,
      },
      {
        selector: "accion",
        name: `${t("providers.table.headers.action")}`,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => this.handleMenu(row.id, open)}
          >
            <ActionMenuListItem
              icon={() => <IconShow className="TextButton__icon--left" />}
              onClick={(e) => this.openInfoTemp(e, row.item)}
            >
              {t(`general.labels.viewProfile`)}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  }

  commitActions = (approve, elements) => {
    const { modal, token, data } = this.state;
    const {
      instance: { instanceAction },
      t,
    } = this.props;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    var approvals = getNumberApprovals(this.props.clientModules, MOD_PROVID);

    if (approvals >= 1) {
      if (token.code === null) {
        token.show = true;
        this.setState({ token, data });
        return false;
      }
    }

    modal.content = loadingHtml();
    modal.show = true;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    this.setState({ modal, data });
    var updateStates = [];

    var apiHeader =
      token.code !== null ? { "x-security-code": token.code } : {};

    Object.keys(data.elements).map((key) => {
      var idProvider = key.split("-")[1];
      updateStates.push({
        providerId: idProvider,
        approve: data.approve,
      });

      return true;
    });

    return instanceAction(
      "/providers/provider-invitation/approve-or-rejected",
      "put",
      updateStates,
      apiHeader
    )
      .then((response) => {
        // if (response.data.data[0].success === false) {
        //   modal.show = true;
        //   modal.content = errorContainer(
        //     `${t('general.labels.errorTitle')}`,
        //     response.data.data[0].message,
        //     {
        //       continueBtn: {
        //         text: `${t('general.buttons.continue')}`,
        //         action: this.closeModal,
        //       },
        //     }
        //   );
        // } else
        if (response.data.notifications == null) {
          this.finishAdmission();
        }

        this.setState({
          contentReady: false,
          token: { show: false, code: null },
        });
        this.getPendingData();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description,
            {
              cancelBtn: {
                text: `${t("general.buttons.close")}`,
                action: () => this.closeModal(),
              },
            }
          );
        }
        modal.onClose = () => this.closeModal();

        this.setState({
          contentReady: false,
          modal,
          token: { show: false, valid: false },
        });
        return this.getPendingData();
      });
  };

  goBack = () => {
    this.setState({ token: { show: false, code: null } });
  };

  render() {
    const {
      contentReady,
      sizePerPage,
      page,
      component,
      companyId,
      providerId,
      list,
      token,
    } = this.state;
    var data = this.getData();
    const { t } = this.props;

    return (
      <React.Fragment>
        {contentReady ? (
          this.props.pending.length > 0 ? (
            list && (
              <React.Fragment>
                <TableAdmissions
                  headers={this.getHeaders()}
                  data={data}
                  page={page}
                  totalSize={this.props.total}
                  sizePerPage={sizePerPage}
                  addmissionType={`providers`}
                  onTableChange={this.handlerTableChange}
                  submitAdmissions={this.commitActions}
                />
                {token.show && (
                  <TokenComponent send={this.validate} goBack={this.goBack} />
                )}
              </React.Fragment>
            )
          ) : (
            <div id="blankAprrovals">
              <img src={noAproval} className="clientImage" />
              <p>{t("admissions.noAdmissions")}</p>
              <div className="line red"></div>
            </div>
          )
        ) : (
          <div className="loader innner"></div>
        )}
        {component && (
          <ProviderTemporal
            closeInfo={this.closeInfo}
            companyId={companyId}
            providerId={providerId}
            invitation={true}
          />
        )}
        <Modal
          show={this.state.modal.show}
          handleClose={this.state.modal.onClose}
        >
          {this.state.modal.content}
        </Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    pending: getPendingProviders(state),
    total: getTotalPendingProviders(state),
    clientModules: getModules(state),
  };
};

export const mapDispatch = (dispatch) => ({
  actions: bindActionCreators(ProviderActions, dispatch),
  instance: bindActionCreators(instanceActions, dispatch),
  getModules: () => dispatch(getAuthenticatedClientModules()),
});

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(InvitationApproval));
